import { z } from "zod";

export const CurrencySchema = z.enum(["EUR", "GBP", "SEK", "USD"]);
export type Currency = z.infer<typeof CurrencySchema>;
